<template>
  <div class="qrcode-con">
    <!--头部-->
    <!--<van-nav-bar :title="headerTitle" left-arrow @click-left="onClickLeft" border/>-->
    <div class="con">
      <div class="logo-con">
        <img class="logo-h" :src="checkQiNiuUrl('ant-www/www20201016/云柑社区logo.png')" alt="">
      </div>
      <div class="header">
        <img v-if="inviteCode==='0608'" class="header-img" src="../../assets/logo.png" alt="">
        <p v-if="inviteCode==='0608'">云柑社区平台</p>

        <img v-if="inviteCode!=='0608'" class="header-img" :src="userInfo.avatar ? (userInfo.avatar+'?imageView2/0/w/150/h/150') : ('/image/avatar.png')" alt="获取头像失败">
        <p v-if="inviteCode!=='0608'">{{ userInfo.nickname }}</p>
        <p v-if="inviteCode!=='0608'">云柑社区号：{{ userInfo.username }}</p>
      </div>
      <!--<qrcode class="qrcodr" :value="qrValue" type="img" :size="220"></qrcode>-->
      <!--<vue-qr :text="qrValue" :size="220"></vue-qr>-->
      <div class="qrcode" id="qrcode"></div>
      <p v-if="inviteCode==='0608'" class="bottom-text">平台邀请信息</p>
      <p v-if="inviteCode!=='0608'" class="bottom-text">扫描二维码，加我好友</p>
    </div>
  </div>
</template>

<script>
  // import VueQr from 'vue-qr'
  import QRCode from 'qrcodejs2'
  import { getUserInfo } from '@/api/my'
  export default {
    props: ['inviteCode'],
    components: {
      // VueQr: VueQr
    },
    data () {
      return {
        userInfo: {},
        headerTitle: '我的邀请码'
      }
    },
    computed:{
      qrValue (){
        if(this.inviteCode === '0608'){
          return this.local('origin') + '/h5/register?inviteCode=0608'
        }else {
          return this.local('origin') + '/h5/register?inviteUserId='+ this.userInfo.openid +'&addfriend=1'
          // return JSON.stringify({account: this.userInfo.openid, type: 1}); //二维码内容
        }
      }
    },
    created(){
      if(this.inviteCode === this.session('user').inviteCode){
        this.headerTitle = '我的邀请码'
      }else {
        this.headerTitle = '我的邀请人'
      }
      document.title = this.headerTitle;

      if(this.inviteCode !== '0608' ) {
        this.getUserInfo({inviteCode: this.inviteCode })
      }else {
        window.setTimeout(()=>{
          this.qrcode();
        },300)
      }
    },
    methods: {
      onClickLeft() {
        this.$router.go(-1)
      },
      getUserInfo(data){
        getUserInfo(data).then(res => {
          if(res.code===200){
            this.userInfo = res.data
            this.qrcode();
          }
        })
      },
      qrcode() {
        console.log('二维码信息:' + this.qrValue)
        new QRCode('qrcode', {
          width: 220,
          height: 220,
          text: this.qrValue, // 二维码地址
          colorDark : "#000",
          colorLight : "#fff",
        })
      },
      /*onCopySuccess(){
        this.$vux.toast.show({text: '复制成功！'});
      },
      onCopyError(){
        this.$vux.toast.show({text: '复制失败！'});
      },*/

    }
  }
</script>

<style scoped lang="less">
@url: 'https://fileqn.anttalk.vip/';
.qrcode-con{
  .con{
    background: url("@{url}FsfzIEOwHcT12KIwfPi-07QBtWY0") no-repeat 50% .2rem;
    background-size: 9.6rem;
    padding: .2rem .2rem 2rem;
    text-align: center;
    min-height: 14rem;
    .logo-con{
      text-align: left;
      .logo-h{
        width: 140px;margin: 6px 12px;
      }
    }



    .header{
      color: white;
      font-size: .4rem;
      p{
        line-height: 1;
        padding: .32rem 0;
      }
      .header-img{
        font-size: 14px;
        width: 2.02rem;
        height: 2.02rem;
        border-radius: 50%;
      }
    }
    .bottom-text{
      color: white;
      font-size: .26rem;
      padding-top: .4rem;
    }
  }
}
</style>
<style lang="less">
  .qrcode-con{
    .qrcode{
      text-align: center;
      img{
        margin: 0 auto;
        padding: 10px;
        background-color: white;
      }
    }
  }
</style>
